import React from 'react';
import { TextInput, BooleanInput, Edit, SimpleForm } from 'react-admin';

const LocationTypeEdit = () => (
  <Edit mutationMode="pessimistic" redirect="show">
    <SimpleForm>
      <TextInput source="label" />
      <BooleanInput source="active" />
      <BooleanInput source="admin_only" />
    </SimpleForm>
  </Edit>
);

export default LocationTypeEdit;
